const CALENDAR_VIEW = {
  day: "day",
  month: "month",
  year: "year"
};
const CALENDAR_TYPE = {
  single: "single-date",
  week: "week-date",
  month: "month-date"
};
export {
  CALENDAR_TYPE,
  CALENDAR_VIEW
};
